import { render, staticRenderFns } from "./VerkaInfoBoxVertical.vue?vue&type=template&id=1149e892&scoped=true&"
import script from "./VerkaInfoBoxVertical.vue?vue&type=script&lang=ts&"
export * from "./VerkaInfoBoxVertical.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaInfoBoxVertical.vue?vue&type=style&index=0&id=1149e892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149e892",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
